/**
 * Price breakdown helpers — aligned with NewBooking.jsx (standard booking, no part-load).
 */
import { calculateB2bBookingPrice } from './b2bPricing';
import { normalizeDiscountPercent } from './bookingQuoteBooking';
import { discountFareAboveBase } from './discountFloor';

export function getEffectiveAmount(computedAmount, override) {
  const parsed = parseFloat(override);
  if (override !== '' && Number.isFinite(parsed) && parsed >= 0) return parsed;
  return computedAmount;
}

export function getPriceBreakdown(vehicleOption, discountPercent, isB2b = false, hasGstin = false) {
  if (!vehicleOption) return null;
  const pct = normalizeDiscountPercent(discountPercent);
  if (isB2b) {
    return calculateB2bBookingPrice(vehicleOption, pct);
  }
  const toll = parseFloat(vehicleOption.toll_price_applied || 0);
  const quoted = discountFareAboveBase(
    parseFloat(vehicleOption.estimated_price),
    pct,
    toll,
    parseFloat(vehicleOption.base_price) || 0,
  );
  const shownPercent = quoted.cappedAtBase ? quoted.effectivePercent : (quoted.discountAmount > 0 ? pct : 0);
  if (hasGstin) {
    const grandTotal = Math.ceil(quoted.total * 1.05);
    return {
      grandTotal,
      discountPercentage: shownPercent,
      gstAmount: grandTotal - quoted.total,
      discountAmount: quoted.discountAmount,
      cappedAtBase: quoted.cappedAtBase,
      basePrice: parseFloat(vehicleOption.base_price) || 0,
    };
  }
  return {
    grandTotal: quoted.total,
    discountPercentage: shownPercent,
    gstAmount: 0,
    discountAmount: quoted.discountAmount,
    cappedAtBase: quoted.cappedAtBase,
    basePrice: parseFloat(vehicleOption.base_price) || 0,
  };
}
